import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { getAction, httpAction } from '@api/manage';
import IwsUpload from '@comp/upload/IwsUpload';
import pick from 'lodash.pick';
import moment from 'moment';
import CarRepairItemModal from "./CarRepairItemModal";
import { queryUserTreeList } from '@/api/api';
var payColumns = [{
  title: '排序',
  dataIndex: '',
  key: 'rowIndex',
  width: '5%',
  align: 'center',
  customRender: function customRender(t, r, index) {
    return parseInt(index) + 1;
  }
}, {
  title: '保险险种',
  dataIndex: 'category_dictText',
  align: 'center',
  width: '20%',
  scopedSlots: {
    customRender: 'category'
  }
}, {
  title: '理赔金额',
  dataIndex: 'premium',
  align: 'center',
  width: '20%',
  scopedSlots: {
    customRender: 'premium'
  }
}, {
  title: '理赔详细',
  dataIndex: 'detailed',
  align: 'center',
  width: '20%',
  scopedSlots: {
    customRender: 'detailed'
  }
}, {
  title: '操作',
  dataIndex: 'operation',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'operation'
  }
}];
/*DataSource 定义数据源数组*/

var payData = []; // PS相关的KEY不能为title关键字

var addPayDataIndex = 0;
export default {
  name: 'CarRepairModal',
  mixins: [ModalFormMixin],
  components: {
    IwsUpload: IwsUpload,
    CarRepairItemModal: CarRepairItemModal
  },
  data: function data() {
    return {
      title: '车辆维保表单',
      tableName: 'ea_asset_car_repair',
      form_fields: ['carId', 'code', 'userId', 'location', 'category', 'totalKilometers', 'fee', 'reason', 'result', 'sort', 'remark'],
      form_fields_time: ['sdate', 'edate'],
      validatorRules: {
        carId: {
          rules: [{
            required: true,
            message: '请选择车牌号!'
          }]
        },
        fee: {
          rules: [{
            required: true,
            message: '请输入维保自费金额!'
          }]
        },
        totalKilometers: {
          rules: [{
            required: true,
            message: '请输入维保总公里!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请选择主要借用人!'
          }]
        },
        location: {
          rules: [{
            required: true,
            message: '请输入维保地址!'
          }]
        },
        category: {
          rules: [{
            required: true,
            message: '请选择维保类别!'
          }]
        },
        reason: {
          rules: [{
            required: true,
            message: '请输入维保原因'
          }]
        },
        result: {
          rules: [{
            required: true,
            message: '请输入维保结果'
          }]
        }
      },
      url: {
        queryCarCards: '/ea/asset/car/queryCarCards',
        queryCarRepairItem: '/ea/asset/car/repair/'
      },
      carId: '',
      loginUser: '',
      carCardsList: [],
      userTree: [],
      //人员信息
      disableStatus: false,
      dateFormat: 'YYYY-MM-DD',
      dateData: {
        startDate: undefined,
        // 维保起始时间
        endDate: undefined // 维保结束时间

      },
      payData: payData,
      addPayDataIndex: addPayDataIndex,
      payColumns: payColumns
    };
  },
  props: {
    permissionObj: {
      type: Object,
      default: function _default() {
        edit: '';
      }
    },
    pagePath: String
  },
  created: function created() {
    this.loginUser = this.$store.getters.userInfo.id;
  },
  methods: {
    moment: moment,

    /**
     * 维保时间
     * @param value
     * @param dateString
     */
    onDateChange: function onDateChange(value, dateString) {
      this.dateData.startDate = dateString[0] == '' ? null : dateString[0];
      this.dateData.endDate = dateString[1] == '' ? null : dateString[1];
    },
    add: function add(carId) {
      this.carId = carId;
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      console.log('this.model', this.model);
      this.visible = true;
      this.disableStatus = false;
      this.addPayDataIndex = 1;
      this.payData = [];

      if (this.model.id == null) {
        this.model.userId = this.loginUser;
        this.model.sdate = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');

        if (this.carId != null) {
          this.model.carId = parseInt(this.carId);
          this.disableStatus = true;
        }
      }

      if (this.model.category == 2) {
        this.loadCarRepairItem(this.model.id);
      }

      this.dateData.startDate = this.model.sdate;
      this.dateData.endDate = this.model.edate;
      this.loadCarCard();
      this.loadTreeList();
      this.$nextTick(function () {
        var that = _this;
        that.form.setFieldsValue(pick(that.model, that.form_fields));
        that.form.setFieldsValue({
          sdate: _this.model.sdate ? moment(_this.model.sdate) : null
        });
        that.form.setFieldsValue({
          edate: _this.model.edate ? moment(_this.model.edate) : null
        });

        _this.$refs.iwupload.loadUploadFiles();
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values);

          if (!formData.code) {
            formData.code = '';
          } //时间格式化


          formData.sdate = that.dateData.startDate;
          formData.edate = that.dateData.endDate;
          formData = _this2.$refs.iwupload.getUploadListToFromData(formData);

          if (_this2.payData != null) {
            formData.items = _this2.payData;
          }

          var httpurl = '',
              method = '';
          var headers = {
            tableName: _this2.permissionObj.edit.split(':')[1]
          };

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';

            if (_this2.permissionObj.edit) {
              headers.id = _this2.model.id; // let largePermission = getLargePermission({ value: that.permissionObj.edit })
              // getBindingValue(headers, largePermission)
            }
          }

          httpAction(httpurl, formData, method, headers).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });

              _this2.$refs.iwupload.resetUploadFiles();

              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }
        }
      });
    },
    loadCarCard: function loadCarCard() {
      var that = this;
      that.carCardsList = [];
      getAction(this.url.queryCarCards).then(function (res) {
        if (res.success) {
          that.carCardsList = res.result;
        }
      });
    },
    selectInsurance: function selectInsurance(carId) {
      if (carId != null) {
        this.$refs.insuranceForm.show(carId);
      } else {
        this.$message.warning('请先选择维修车辆');
        return;
      }
    },
    // 增加保险险种
    addInsurance: function addInsurance(insurance) {
      insurance.key = 'A' + this.addPayDataIndex;
      this.payData.push(insurance);
      this.addPayDataIndex = this.addPayDataIndex + 1;
    },
    // 删除保险险种
    delInsurance: function delInsurance(key) {
      var newData = this.payData.filter(function (item) {
        return key != item.key;
      });
      this.payData = newData;
    },
    total: function total(i) {
      var togglePrice = 0;
      this.payData.forEach(function (data) {
        if (data.premium != null) {
          togglePrice += data.premium;
        }
      });
      return togglePrice;
    },
    loadCarRepairItem: function loadCarRepairItem(params) {
      var that = this;
      getAction(this.url.queryCarRepairItem + params).then(function (res) {
        if (res.success) {
          console.log('res', res);
          var paramList = [];

          for (var i = 0; i < res.result.items.length; i++) {
            var param = res.result.items[i];
            param.key = param.id;
            param.editable = false;
            paramList.push(param);
          }

          that.payData = paramList;
          console.log('that.payData', that.payData);
        }
      });
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};